<template>
  <div class="select-box" v-show="show">
    <a-collapse class="select-list" default-active-key="2">
      <!-- <a-collapse-panel header="默认图标" key="1">
        <div
          class="select-item"
          v-for="(item, i) in list"
          :key="i"
          @click.stop="select(item)"
        >
          <div class="select-img" :class="[item.icon]"></div>
        </div>
      </a-collapse-panel> -->
      <a-collapse-panel header="自定义图标" key="2">
        <div
          class="select-item"
          v-for="(item, i) in editlist"
          :key="i"
          @click.stop="select(item)"
        >
          <div class="select-img">
            <img :src="item.url" v-if="item.url" />
          </div>
        </div>
      </a-collapse-panel>
    </a-collapse>
    <a-icon type="close" class="close-btn" @click="hide"/>
  </div>
</template>

<script>
export default {
  name: "icon-select",
  data() {
    return {
      show: false,
      hideFlag: false,
      list: [
        { icon: "icon-article" },
        { icon: "icon-article-line" },
        { icon: "icon-hotel" },
        { icon: "icon-hotel-line" },
        { icon: "icon-home" },
        { icon: "icon-home-line" },
        { icon: "icon-person" },
        { icon: "icon-person-line" },
        { icon: "icon-list" },
        { icon: "icon-list-num" },
        { icon: "icon-enroll" },
        { icon: "icon-enroll-line" },
        { icon: "icon-login" },
        { icon: "icon-login-line" },
        { icon: "icon-sch" },
        { icon: "icon-date" },
        { icon: "icon-link" },
        { icon: "icon-url" },
      ],
      editlist: [],
    };
  },
  created() {
    this.geteditlist();
  },
  methods: {
    showIcons() {
      this.show = true;
    },
    select(item) {
      this.$emit("select", item);
      this.hide();
    },
    hide() {
      this.show = false;
    },
    geteditlist() {
      this.$axios("/activity/activity-icon?page=1&pageSize=1000").then(
        (res) => {
          this.editlist = res.data;
        }
      );
    },
  },
};
</script>

<style lang="less">
.select-box {
  --box-shadow: 0 2px 3px 0 rgb(0 0 0 / 20%);
  --back-white-color: #fff;
  --border-color: #dcdfe6;
  --border: 1px solid var(--border-color);
  --main-color: #004098;
  --text-font-color: #606266;
  --tip-font-color: #909399;

  padding: 30px 30px 16px;
  box-shadow: var(--box-shadow);
  background-color: var(--back-white-color);
  border: var(--border);
  border-radius: 4px;
}
.select-list {
  margin: 10px auto;
  width: 360px;
}
.select-item {
  display: inline-block;
  position: relative;
  margin: 0 10px 20px 10px;
  width: 48px;
  height: 48px;
  border: var(--border);
  cursor: pointer;
  overflow: hidden;
  text-align: center;
  &:hover {
    border-color: var(--main-color);
    box-shadow: 0 0 6px #aed1f3;
  }
}
.select-img {
  display: inline-block;
  width: 24px;
  height: 24px;
  font-size: 24px;
  color: var(--text-font-color);
  line-height: 48px;
}
.select-img img {
  width: 100%;
  vertical-align: middle;
}
.item-upload .cl-upload-item {
  display: inline-block;
  padding: 12px;
  width: 100%;
}
.item-upload .cl-upload-item .upload-item-ctx {
  border: none;
}
.item-upload .cl-upload-item .upload-item-ctx .add-icon {
  width: auto;
  height: auto;
}
.close-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 30px;
  height: 30px;
  font-size: 24px;
  line-height: 30px;
  color: @text-color-secondary;
}
</style>
